var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlertaDeDesconexionDeTomaDeFuerza(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ba0202;}.cls-3{fill:#a30000;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-alerta-de-desconexion-de-toma-de-fuerza") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_38_copia_13",
    "data-name": "38 copia 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.25,165.22a28.69,28.69,0,0,0,57.37,0c0-.5,0-1,0-1.48a28.69,28.69,0,0,0-57.3,0C97.26,164.23,97.25,164.72,97.25,165.22Zm10.3,0c0-.5,0-1,.07-1.48a18.37,18.37,0,0,1,36.63,0c0,.49.06,1,.06,1.48a18.38,18.38,0,1,1-36.76,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.91,150a24.95,24.95,0,0,1,44,0,24.44,24.44,0,0,1,2.91,10.46c0,.42,0,.85,0,1.28a24.58,24.58,0,0,1-.24,3.45h-2.89a21.9,21.9,0,0,0,.27-3.45c0-.55,0-1.12-.07-1.77a22.1,22.1,0,0,0-44.05,0c-.06.65-.08,1.22-.08,1.77a21.9,21.9,0,0,0,.27,3.45h-2.89a24.58,24.58,0,0,1-.24-3.45c0-.43,0-.86,0-1.28h0A24.73,24.73,0,0,1,103.91,150Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.14,133.05a32.41,32.41,0,0,0-13.52,13.43,32,32,0,0,0-3.78,13.59c0,.55,0,1.11,0,1.66a32.93,32.93,0,0,0,.18,3.45H58.09L68,133.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.06,161.73c0-.55,0-1.11,0-1.66a31.89,31.89,0,0,0-3.78-13.59,32.41,32.41,0,0,0-13.52-13.43h60.56v32.13h-43.4A32.93,32.93,0,0,0,164.06,161.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.81 124.64 109.7 124.64 205.92 72.98 218.81 124.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "205.92 54.4 205.92 72.98 32.55 166.13 24.79 151.72 205.92 54.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.41 96.34 176.83 88.6 163.54 77.16 149.12 84.9 162.41 96.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.5 80.72 205.92 72.98 192.63 61.54 178.21 69.28 191.5 80.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.82 112.22 147.24 104.48 133.95 93.04 119.53 100.78 132.82 112.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.56 127.94 117.98 120.19 104.69 108.75 90.26 116.49 103.56 127.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.97 143.82 88.39 136.08 75.1 124.64 60.68 132.38 73.97 143.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.84 158.92 60.26 151.18 46.97 139.74 32.55 147.48 45.84 158.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 42.07,
    y1: 42.63,
    x2: 186.96,
    y2: 186.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 100.51,
    y: 12.53,
    width: 28,
    height: 204.48,
    transform: "translate(-47.62 114.92) rotate(-45.12)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlertaDeDesconexionDeTomaDeFuerza);
export default __webpack_public_path__ + "static/media/ic-alerta-de-desconexion-de-toma-de-fuerza.c8ced791f76fd2c8542d2580aa2b492d.svg";
export { ForwardRef as ReactComponent };